import { CommandType } from '../constants/Constants';
import CmdEraser from './CmdEraser';
import CmdNull from './CmdNull';
import CmdUndo from './CmdUndo';
import CmdRedo from './CmdRedo';
import CmdZoom from './CmdZoom';
import CmdRemoveAll from './CmdRemoveAll';
/**
 * 命令工厂
 *
 * @export
 * @class CommandFactory
 * @author zhenliang.sun
 */
export default class CommandFactory {
  constructor() {
    this.app = null;
  }

  createCommand(id) {
    let cmd;
    switch (id) {
      case CommandType.Eraser:
        cmd = new CmdEraser();
        break;
      case CommandType.Undo:
        cmd = new CmdUndo();
        break;
      case CommandType.Redo:
        cmd = new CmdRedo();
        break;
      case CommandType.Zoom:
        cmd = new CmdZoom();
        break;
      case CommandType.RemoveAll:
        cmd = new CmdRemoveAll();
        break;
      default:
        cmd = new CmdNull();
        break;
    }
    cmd.app = this.app;
    return cmd;
  }
}
